import api from '../utils/api'

export const createDeposit = async (deposit) => {

    try {
        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const body = {
            sigla: deposit.sigla,
            uf: deposit.uf,
            cidade: deposit.cidade,
            endereco: deposit.endereco,
        }

        const data = await api.post('/deposits/create', body).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        return null        
    }

}

export const getDeposits = async (filter) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(filter ? `/deposits${filter}`:`/deposits`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        return null
        
    }
}

const DepositService = {
    getDeposits,
    createDeposit
}

export default DepositService